import script from "./Layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout.vue?vue&type=script&lang=ts&setup=true"

import "./Layout.vue?vue&type=style&index=0&id=4cb83473&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb83473"]])

export default __exports__